// extracted by mini-css-extract-plugin
export default {"toggle":"-y00L","tooltip":"_1tiBn","badge-icon":"_1P7ex","badgeIcon":"_1P7ex"};